import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=56b8807e&scoped=true"
import script from "./HelpText.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HelpText.vue?vue&type=style&index=0&id=56b8807e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8807e",
  null
  
)

export default component.exports